module.exports = __webpack_public_path__ + "img/portfolio-2.82725237.jpg";